<!--
  Shows an in-flight (or failed) AI plan draft.

  The status is read from the server, not held in this component, so it survives a page reload and is visible
  to a second admin looking at the same audience.
-->
<template>
  <v-alert
    v-if="visible"
    :type="failed ? 'error' : 'info'"
    text
    border="left"
    class="mb-4"
  >
    <div class="d-flex align-center flex-wrap">
      <div class="mr-4">
        {{ message }}
      </div>
      <v-spacer />
      <v-btn
        v-if="failed"
        small
        outlined
        color="error"
        @click="$emit('retry')"
      >
        Try again
      </v-btn>
    </div>

    <v-progress-linear
      v-if="!failed"
      indeterminate
      rounded
      height="3"
      class="mt-2"
      color="mcsprimary"
    />
  </v-alert>
</template>

<script>
export default {
  name: 'AudienceGenerationBanner',
  props: {
    // See AUDIENCE.GENERATION_STATUS.
    status: {
      type: Number,
      default: 1
    },
    // Failure reason from the server.
    serverMessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    failed() {
      return this.status === this.$enums.AUDIENCE.GENERATION_STATUS.FAILED;
    },
    visible() {
      const s = this.$enums.AUDIENCE.GENERATION_STATUS;
      return this.status === s.QUEUED || this.status === s.RUNNING || this.failed;
    },
    message() {
      const s = this.$enums.AUDIENCE.GENERATION_STATUS;
      if (this.failed) return this.serverMessage || 'The plan could not be generated.';
      if (this.status === s.QUEUED) return 'Queued — the plan will start generating shortly.';
      return 'Building the plan. This takes a minute; you can leave this page and come back.';
    }
  }
};
</script>
